/**
 * Carta intestata Santa Maria Valleverde per tutte le stampe.
 * Header con logo reale, fascia verde a piè di pagina con QR, filigrana.
 * Header e footer sono fissi nei margini di pagina: si ripetono su ogni foglio.
 */
import { toast } from 'sonner';

const ORIGIN = typeof window !== 'undefined' ? window.location.origin : '';
export const LOGO_URL = `${ORIGIN}/logo_valleverde.png`;
export const QR_URL = `${ORIGIN}/qr_valleverde.png`;
export const WATERMARK_URL = `${ORIGIN}/watermark_valleverde.png`;

export function generateLetterheadHTML(title, bodyContent, options = {}) {
  const { date, subtitle, showWatermark = true } = options;
  const dateStr = date || new Date().toLocaleDateString('it-IT', { day: 'numeric', month: 'long', year: 'numeric' });
  const sedeNome = (typeof localStorage !== 'undefined' && localStorage.getItem('rsa_sede_nome')) || '';
  const sedeRiga = sedeNome && sedeNome !== 'Tutte le sedi' ? `Sede: ${sedeNome}` : 'Piazza Santa Maria, 1 - 67043 Celano (AQ)';

  return `<!DOCTYPE html><html><head><meta charset="utf-8"><title>${title}</title>
<style>
@import url('https://fonts.googleapis.com/css2?family=Cinzel:wght@600;700&family=Raleway:wght@400;500;600;700&display=swap');
* { margin: 0; padding: 0; box-sizing: border-box; }
body { font-family: 'Raleway', Arial, sans-serif; color: #1e293b; font-size: 10.5px; line-height: 1.45; }
@page { size: A4; margin: 20mm 9mm 13mm 9mm; }
.hdr { display: flex; align-items: flex-end; justify-content: space-between; gap: 12px; border-bottom: 1.5px solid #0C8E36; padding-bottom: 4px; }
.hdr img { height: 30px; }
.hdr-right { font-size: 8px; color: #64748b; text-align: right; letter-spacing: .3px; }
.ftr { background: #0C8E36; color: #fff; height: 9mm; display: flex; align-items: center; justify-content: center; gap: 18px; font-size: 8px; letter-spacing: .2px; }
.ftr-qr { position: absolute; right: 4mm; bottom: 0.5mm; height: 8mm; background: #fff; padding: 0.5mm; }
.ftr-item { display: flex; align-items: center; gap: 3px; }
.doc-meta { display: flex; justify-content: space-between; align-items: flex-start; padding: 6px 0 4px; border-bottom: 1px solid #e2e8f0; margin-bottom: 6px; }
.doc-title { font-family: 'Cinzel', Georgia, serif; font-size: 14px; font-weight: 700; color: #064e2b; letter-spacing: .3px; }
.doc-subtitle { font-size: 9.5px; color: #64748b; margin-top: 1px; }
.doc-date { font-size: 9px; color: #64748b; text-align: right; white-space: nowrap; }
.content { position: relative; z-index: 2; }
.watermark { position: fixed; top: 45%; left: 50%; transform: translate(-50%, -50%); opacity: 0.06; z-index: 0; pointer-events: none; width: 120mm; }
table { border-collapse: collapse; width: 100%; margin: 6px 0; }
th { background: #eef7f1; padding: 4px 6px; border: 1px solid #d7e5dc; text-align: left; font-size: 8.5px; font-weight: 700; color: #0f5132; text-transform: uppercase; letter-spacing: 0.4px; }
td { padding: 4px 6px; border: 1px solid #e2e8f0; font-size: 9.5px; }
tr:nth-child(even) { background: #f8fafc; }
.section-title { font-size: 11px; font-weight: 700; color: #0C8E36; margin: 10px 0 4px; padding-bottom: 3px; border-bottom: 1px solid #d1d5db; }
.badge { display: inline-block; padding: 1px 7px; border-radius: 10px; font-size: 8.5px; font-weight: 600; }
.badge-red { background: #fee2e2; color: #dc2626; }
.badge-green { background: #dcfce7; color: #0C8E36; }
.badge-amber { background: #fef3c7; color: #d97706; }
.badge-blue { background: #dbeafe; color: #2563eb; }
.signature-row { display: flex; justify-content: space-between; margin-top: 30px; }
.signature-block { border-top: 1px solid #333; padding-top: 4px; width: 180px; text-align: center; font-size: 8.5px; color: #64748b; }
.info-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 3px 14px; margin: 5px 0; }
.info-item { font-size: 9.5px; }
.info-label { color: #64748b; font-size: 8.5px; }
.info-value { font-weight: 600; color: #1e293b; }
.alert-box { padding: 6px 10px; border-radius: 5px; margin: 5px 0; border-left: 3px solid; font-size: 9.5px; }
.alert-red { background: #fef2f2; border-color: #dc2626; color: #991b1b; }
.alert-amber { background: #fffbeb; border-color: #d97706; color: #92400e; }
@media print {
  .no-print { display: none !important; }
  body { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
  .hdr { position: fixed; top: -16mm; left: 0; right: 0; }
  .ftr { position: fixed; bottom: -12mm; left: -9mm; right: -9mm; }
}
@media screen {
  body { background: #f1f5f9; }
  .sheet { width: 210mm; min-height: 297mm; margin: 16px auto; background: #fff; padding: 10mm 9mm 0; position: relative; box-shadow: 0 4px 24px rgba(0,0,0,.12); display: flex; flex-direction: column; }
  .sheet-body { flex: 1; padding-bottom: 12mm; }
  .ftr { position: absolute; bottom: 0; left: 0; right: 0; }
}
</style></head><body>
<div class="sheet">
  <div class="hdr">
    <img src="${LOGO_URL}" alt="Santa Maria Valleverde" />
    <div class="hdr-right">Residenza Socio-Assistenziale Protetta<br/>${sedeRiga}</div>
  </div>
  <div class="sheet-body">
    <div class="doc-meta">
      <div>
        <div class="doc-title">${title}</div>
        ${subtitle ? `<div class="doc-subtitle">${subtitle}</div>` : ''}
      </div>
      <div class="doc-date">Celano, ${dateStr}</div>
    </div>
    ${showWatermark ? `<img class="watermark" src="${WATERMARK_URL}" alt="" />` : ''}
    <div class="content">${bodyContent}</div>
  </div>
  <div class="ftr">
    <span class="ftr-item">Piazza Santa Maria, 1 &bull; 67043 - Celano (AQ)</span>
    <span class="ftr-item">Tel. 0863 790322</span>
    <span class="ftr-item">santamariavalleverde@pec.it</span>
    <img class="ftr-qr" src="${QR_URL}" alt="" />
  </div>
</div>
<button class="no-print" onclick="window.print()" style="display:block;margin:20px auto;padding:10px 24px;background:#0C8E36;color:white;border:none;border-radius:8px;cursor:pointer;font-family:Raleway;font-size:13px;font-weight:600">Stampa Documento</button>
</body></html>`;
}

/** Testo sicuro per l'HTML delle stampe (evita che i dati inseriti diventino codice). */
export function escapeHtml(valore) {
  return String(valore ?? '').replace(/[&<>"']/g, (c) =>
    ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
}

/** Apre una finestra di stampa da HTML completo, senza usare document.write. */
export function openHtmlWindow(html, features = '_blank') {
  const url = URL.createObjectURL(new Blob([html], { type: 'text/html' }));
  const w = features === '_blank'
    ? window.open(url, '_blank')
    : window.open(url, '_blank', features);
  if (!w) {
    URL.revokeObjectURL(url);
    toast.error('Consenti le finestre popup per stampare questo documento');
    return null;
  }
  setTimeout(() => URL.revokeObjectURL(url), 5 * 60 * 1000);
  return w;
}

export function openPrintWindow(title, bodyContent, options = {}) {
  return openHtmlWindow(generateLetterheadHTML(title, bodyContent, options));
}
